export default __webpack_public_path__ + "static/media/login_smartphone_2.77024d21.png";